//Detect class change on <body> with MutationObserver
function detectClassChange(el) {
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                let className = mutation.target.className;
                if (className.includes('js-my-cart-open')) {
                    document.body.style.overflow = 'hidden';
                    if (window.lenis != null) {
                        window.lenis.stop();
                    }

                } else{
                    document.body.style.overflow = 'auto';
                    if (window.lenis != null) {
                        window.lenis.start();
                    }
                }
            }
        });
    });
    observer.observe(el, {
        attributes: true
    });
}

detectClassChange(document.body);

function addSafariClass() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const safariVersion = Number((navigator.userAgent.match(/Version\/([\d]+)/) || [0, 0])[1]);
    if (isSafari && safariVersion < 13) {
        document.body.classList.add('is-old-safari');
    }
}

addSafariClass();



// Image Animation
function imageAnimation() {
    const imageSections = document.querySelectorAll('.section-image__wrapper');

    if (imageSections.length < 0) return

    gsap.utils.toArray(imageSections).forEach((section) => {
        const image = section.querySelectorAll('img');
    
        const imageAnim = 
            gsap.timeline()
                .from(image,{
                    scrollTrigger: {
                        trigger: section,
                        start: '-80% center',
                        end: '20% top',
                        // markers: true,
                        scrub: true,
                        once: false
                    },
                    duration: 1.4,
                    delay: .7,
                    scale: 1.25,
                    ease: 'power3.inOut',
                })
    })
}
imageAnimation();

// Paragraph Animation
function paragraphAnimation() {
    const sections = document.querySelectorAll('.section-text__wrapper');

    if (sections.length == 0) return

    gsap.utils.toArray(sections).forEach((section) => {
        const currentParagraph = section.querySelector('[data-animation="paragraph"] > p');

        const currentText = new SplitText(currentParagraph, { 
            type: 'lines,words',
            linesClass: 'line--++',
            wordsClass: 'word--++',
        });

        const textAnim = 
            gsap.timeline()
                .from(currentText.lines, {
                    scrollTrigger: {
                        trigger: section,
                        start: '-70% bottom-=30%',
                        end: '20% bottom-=60%',
                        // markers: true,
                        // once: true,
                        scrub: 1,
                    },
                    opacity: 0,
                    y: 40,
                    webkitFilter: 'blur(4px)',
                    filter: 'blur(4px)',
                    duration: 1.2,
                    stagger: 0.12
                })
    })  
}
paragraphAnimation();


// Heading Animation
function headingAnimation(){
    const sections = document.querySelectorAll('.big-heading-with-links__wrapper');

    if (sections.length == 0) return

    gsap.utils.toArray(sections).forEach((section) => {
        const currentHeading = section.querySelector('[data-animation="heading"]');
        const heading = new SplitText(currentHeading, {
            type: 'chars',
            wordsClass: 'char--++',
        });

        gsap.from(heading.chars, {
            scrollTrigger: {
                trigger: section,
                start: '-50% bottom-=100px',
                end: '+50% +=50%',
                // markers: true,
                scrub: true,
                once: false,
            },
            yPercent: 100,
            delay: .4,
            opacity: 0,
            duration: .8,
            stagger: 0.05
        })
    })
}
headingAnimation();

// Featured Logos Animation
function featuredLogosAnimation() {
    const sections = document.querySelectorAll('.featured-logos__wrapper');

    if (sections.length == 0) return

    gsap.utils.toArray(sections).forEach((section) => {
        const logo = section.querySelectorAll('.featured-logos__logo-item');

        gsap.from(logo, {
            scrollTrigger: {
                trigger: section,
                start: '-50% bottom-=100px',
                end: '+50% +=50%',
                // markers: true,
                once: false,
                scrub: 1,
            },
            autoAlpha: 0,
            y: 20,
            stagger: 0.15,
            duration: 1.3,
            ease: 'power2.inOut'
        })
    })
}
featuredLogosAnimation();


//pause all gsap animations
gsap.globalTimeline.pause()


setTimeout(() => {
    gsap.to('.loader', {
        display: 'none',
        delay: .5,
        autoAlpha: 0,
        duration: .4,
        ease: 'power3.out'
    })
    gsap.globalTimeline.play()  
}, 1100);


document.addEventListener('DOMNodeInserted', (e) => {
    const instaFeedImage = document.querySelectorAll('.instafeed-container');
    if (instaFeedImage.length < 0) return
    ScrollTrigger.refresh();

    if (window.location.pathname === '/') {
        instaModule();
    }
});

[...document.querySelectorAll('summary')].forEach((item) => {
    item.addEventListener('click', () => {
        setTimeout(
            () => {
                ScrollTrigger.refresh();
            }, 1100
        )
    })
})

function instaModule() {
    const instaFeedContainer = document.querySelector('#insta-feed');
    const instaFeedImage = document.querySelectorAll('.instafeed-container');

    if(!instaFeedContainer) return
    const closeBtn = instaFeedContainer.querySelectorAll('.close-button')
    if (instaFeedImage.length < 0) return

    // instaFeedImage.forEach(section => {
    //     section.addEventListener('click', (e) => {
    //         smoother.kill();
    //     })
    // })

    // closeBtn.forEach(btn => {
    //     btn.addEventListener('click', (e) => {
    //         setTimeout(() => {
    //             desktopSmoothScroll();
    //         }, 250);
    //     })
    // })
}


function tableAnim() {
    const table = document.querySelectorAll('.table');

    if (table.length == 0) return

    const tableTl = gsap
        .timeline({
            paused: true,
            ease: 'power2.out',
        })
        .from('.table th', {
            duration: .7,
            delay: .05,
            xPercent: 30,
            stagger: 0.06,
        }, 0)
    
        .from('.table td', {
            duration: .7,
            delay: .05,
            xPercent: -50,
            stagger: 0.06,
        }, 0)
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                tableTl.play();
                console.log("in")
            } 
            else {
                tableTl.reverse();
                console.log("out")
            }
        })
    })
    
    observer.observe(document.querySelector('.multicolumn-text__wrapper table'))
}

tableAnim();

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);



function ingredientsSectionAnimation() {
    gsap.utils.toArray(document.querySelectorAll('textPath')).forEach(path => {
        console.log(path)
    
        const pathAnim = gsap.timeline({
            paused: true,
        })
    
        pathAnim.from(path, {
            attr: {
                startOffset: '30%',
            },
            duration: 1.2,
            delay: .15,
            ease: 'power2.out',
            stagger: 3
        })
    
        
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    pathAnim.play();
                } else{
                    pathAnim.reverse();
                }
            })
        })
    
        observer.observe(path)
    })
}

ingredientsSectionAnimation();

function productCardAnimation(){
    const productCard = document.querySelectorAll('.product-card__container');
    const productCardInView = document.querySelectorAll('.product-card__container.product-card__container--in-view');
    if (productCard.length == 0) return
    
    const cardTl = gsap
        .timeline({
            paused: true,
            ease: 'power3.inOout',
        })
        .from(productCard, {
            duration: 1.2,
            yPercent: 20,
            stagger: 0.2,
        }, 0)

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('product-card__container--in-view')
                cardTl.play();
                // console.log("e", entry)
            }
        })
    })
    productCard.forEach(card => {
        // console.log('c', card)
        observer.observe(card)
    })
}

productCardAnimation();



class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        console.log("JSON", this.querySelector('[type="application/json"]').textContent)

        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        // this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            console.log('not var')
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateMasterSelect();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
        console.log('option', this.options)
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });

        console.log("currentVar", this.currentVariant)
    }

    updateMasterSelect() {
        const masterSelect = document.getElementById(`product-select-${this.dataset.section}`);
        if (!masterSelect) return;
        masterSelect.value = this.currentVariant.id;
        masterSelect.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        console.log('update media')

        // const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        // // mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

        // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        // if (!modalContent) return;
        // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        // modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        console.log("form", productForms);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
            console.log('input', input)
        });
    }

    renderProductInfo() {
        console.log("render ent");
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);
                console.log(price)

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
        console.log("render end")
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        console.log("field", fieldsets)
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
        console.log("options", this.options);
    }
}
customElements.define('variant-radios', VariantRadios);
